import React from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { renderMoney } from '@/utils/helpers';

const MetricLabel = ({ label, description }) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
        <span>{label}</span>
        <Tooltip placement="top" title={description}>
            <QuestionCircleOutlined style={{ color: '#8c8c8c', fontSize: 11, cursor: 'help' }} />
        </Tooltip>
    </span>
);

const RevenueSummaryCell = ({
    financialOverview = {},
    align = 'right',
}) => {
    const totalRevenue = Math.max(0, Number(financialOverview.total_revenue_amount || 0));
    const totalPaid = Math.max(0, Number(financialOverview.total_paid_amount || 0));
    const totalDebt = Math.max(0, Number(financialOverview.total_outstanding_amount || 0));
    const paidPercent = Math.max(0, Number(financialOverview.paid_percent || 0));

    let percentColor = '#1677ff'; // >= 100% (xanh dương)
    if (paidPercent < 50) {
        percentColor = '#fa8c16';
    } else if (paidPercent < 100) {
        percentColor = '#531dab';
    }

    return (
        <div style={{ textAlign: align, lineHeight: 1.6 }}>
            <div style={{ fontSize: 12, color: '#595959' }}>
                <MetricLabel
                    label="Tổng doanh số:"
                    description="Doanh số dịch vụ sau ưu đãi cộng toàn bộ giá trị sản phẩm đã bán."
                />{' '}
                <span style={{ fontWeight: 600, color: '#262626' }}>
                    {renderMoney(totalRevenue)}
                </span>
            </div>

            <div style={{ fontSize: 12, color: '#389e0d', fontWeight: 500 }}>
                <MetricLabel
                    label="Đã thanh toán:"
                    description="Tiền đã dùng thanh toán dịch vụ cộng tiền sản phẩm đã thanh toán."
                />{' '}
                {renderMoney(totalPaid)}
            </div>

            <div style={{ fontSize: 12, color: '#cf1322', fontWeight: 500 }}>
                <MetricLabel
                    label="Còn nợ:"
                    description="Số tiền khách còn phải thanh toán."
                />{' '}
                {renderMoney(totalDebt)}
            </div>

            <div
                style={{
                    fontSize: 12,
                    fontWeight: 500,
                    color: percentColor
                }}
            >
                <MetricLabel
                    label="Tỷ lệ thanh toán:"
                    description="Đã thanh toán chia cho Tổng doanh số."
                />{' '}
                {paidPercent}%
            </div>
        </div>
    );
};

export default RevenueSummaryCell;
